const DoubleArrowIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="8,18 12,22 16,18"></polyline>
        <polyline points="8,6 12,2 16,6"></polyline>
        <line x1="12" y1="2" x2="12" y2="22"></line>
    </svg>
);

export default DoubleArrowIcon;
